import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { BtnGroup, TempInput } from '../common';
import resultRouter from './resultRouter';

const useStyles = makeStyles({
  question: {
    fontWeight: '500'
  }
});

const QuestionnaireSteps = ({
  locale,
  questions,
  step,
  setStep,
  sendResponse,
  assignRisk
}) => {
  const classes = useStyles();
  const [hasSymptoms, setHasSymptoms] = useState(false);
  const [temp, setTemp] = useState('not provided');

  const goToTemp = () => setStep(2);
  const goToCriticalSymptomes = () => setStep(3);

  const getIsTempUnderThreshhold = submittedTemp =>
    submittedTemp === 'not provided' ? true : submittedTemp < 100;

  const getQuestionText = (questions, id) => {
    const question = questions.find(q => q.id === id);

    if (question) {
      switch (locale.id) {
        case 'en':
          return question.questionTextEnUs;
        case 'es':
          return question.questionTextEsUs;
        default:
          return question.questionTextEnUs;
      }
    } else {
      return 'Question Not Found';
    }
  };

  const handleResponse = (submittedTemp, hasCriticalSymptomes) =>
    resultRouter(
      {
        hasSymptoms,
        isTempUnderThreshhold: getIsTempUnderThreshhold(submittedTemp),
        hasCriticalSymptomes,
        temp: submittedTemp
      },
      assignRisk
    );

  switch (step) {
    case 1:
      return (
        <div>
          <p className={classes.question}>
            {getQuestionText(questions, 11).replace('?', ':')}{' '}
          </p>
          <ul>
            {locale.questionnaire.symptoms.map((item, index) => (
              <li key={`sympt-${index}`}>{item}</li>
            ))}
          </ul>
          <BtnGroup
            btns={[
              {
                text: locale.button_labels.yes,
                value: 'yes',
                callback: responseText =>
                  sendResponse(11, responseText, () => {
                    setHasSymptoms(true);
                    goToTemp();
                  })
              },
              {
                text: locale.button_labels.no,
                value: 'no',
                callback: responseText =>
                  sendResponse(11, responseText, () => {
                    setHasSymptoms(false);
                    goToTemp();
                  })
              }
            ]}
          />
        </div>
      );

    case 2:
      return (
        <div>
          <p className={classes.question}>{getQuestionText(questions, 12)}</p>
          <TempInput
            locale={locale}
            onSubmit={returnedTemp =>
              sendResponse(12, returnedTemp, () => {
                setTemp(returnedTemp);
                if (hasSymptoms && getIsTempUnderThreshhold(returnedTemp)) {
                  goToCriticalSymptomes();
                } else {
                  handleResponse(returnedTemp, false);
                }
              })
            }
          />
        </div>
      );

    case 3:
      return (
        <div>
          <p className={classes.question}>{getQuestionText(questions, 14)}</p>
          <ul>
            {locale.questionnaire.critical_symptoms.map((item, index) => (
              <li key={`crit-sympt-${index}`}>{item}</li>
            ))}
          </ul>
          <BtnGroup
            btns={[
              {
                text: locale.button_labels.yes,
                value: 'yes',
                callback: responseText =>
                  sendResponse(14, responseText, () => {
                    handleResponse(temp, true);
                  })
              },
              {
                text: locale.button_labels.no,
                value: 'no',
                callback: responseText =>
                  sendResponse(14, responseText, () => {
                    handleResponse(temp, false);
                  })
              }
            ]}
          />
        </div>
      );

    default:
      return null;
  }
};

export default QuestionnaireSteps;
